import { motion } from "framer-motion";
import { 
  Trophy, 
  LayoutDashboard, 
  TrendingUp, 
  Award, 
  Sparkles, 
  ClipboardCheck, 
  Users, 
  Smartphone 
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const PlatformFeatures = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Trophy,
      titleKey: "platformFeatures.features.silvaCoin.title",
      descriptionKey: "platformFeatures.features.silvaCoin.description",
      gradient: "from-primary/20 to-accent/20"
    },
    {
      icon: LayoutDashboard,
      titleKey: "platformFeatures.features.learningHub.title",
      descriptionKey: "platformFeatures.features.learningHub.description",
      gradient: "from-accent/20 to-secondary/20"
    },
    {
      icon: TrendingUp,
      titleKey: "platformFeatures.features.progressTracking.title",
      descriptionKey: "platformFeatures.features.progressTracking.description",
      gradient: "from-secondary/20 to-primary/20"
    },
    {
      icon: Award,
      titleKey: "platformFeatures.features.achievements.title",
      descriptionKey: "platformFeatures.features.achievements.description",
      gradient: "from-primary/20 to-accent/20"
    },
    {
      icon: Sparkles,
      titleKey: "platformFeatures.features.aiHelp.title",
      descriptionKey: "platformFeatures.features.aiHelp.description",
      gradient: "from-accent/20 to-secondary/20"
    },
    {
      icon: ClipboardCheck,
      titleKey: "platformFeatures.features.quizzes.title",
      descriptionKey: "platformFeatures.features.quizzes.description",
      gradient: "from-secondary/20 to-primary/20"
    },
    {
      icon: Users,
      titleKey: "platformFeatures.features.community.title",
      descriptionKey: "platformFeatures.features.community.description",
      gradient: "from-primary/20 to-accent/20"
    },
    {
      icon: Smartphone,
      titleKey: "platformFeatures.features.mobile.title",
      descriptionKey: "platformFeatures.features.mobile.description",
      gradient: "from-accent/20 to-secondary/20"
    }
  ];
  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-primary bg-clip-text text-transparent"
          >
            {t('platformFeatures.title')}
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto"
          >
            {t('platformFeatures.subtitle')}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="h-full min-h-[280px] bg-card/30 backdrop-blur-xl border-white/10 hover:border-primary/30 transition-all duration-300 group hover:shadow-glass-hover">
                <CardContent className="p-6">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <feature.icon className="w-7 h-7 text-primary" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold mb-2 min-h-[60px] text-foreground group-hover:text-primary transition-colors">
                    {t(feature.titleKey)}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {t(feature.descriptionKey)}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
